import React from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import TopBanner from "./TopBanner";
import CourseInformation from "./CourseInfromation";
import DoubleBanners from "./DoubleBanners";
import RoshanaSlider from "./BannerSlider";
import WhyEnroll from "./WhyEnroll";
import Faq from "./Faq";
import Awards from "./awards";

const Roshana = () => {
  return (
    <AnimatedPageContainer>
      <div className="w-100">
        <TopBanner />
        <CourseInformation />
        <DoubleBanners />
        <RoshanaSlider />
        <WhyEnroll />
        <Faq />
        <Awards />
      </div>
    </AnimatedPageContainer>
  );
};

export default Roshana;
